export default __webpack_public_path__ + "static/media/gallery-wip-neck-grenade_05.cbdd07eb.jpg";